// custom style by insert css rules
import Cookies from 'js-cookie'

const addRules = rules => {
  var style = document.createElement('style')
  // WebKit hack :(
  style.appendChild(document.createTextNode(''))
  document.head.appendChild(style)
  const sheet = style.sheet

  rules.forEach((rule, i) => {
    sheet.insertRule(rule, i)
  })
}

export default () => {
  // 主题颜色自定义
  let themeColors = Cookies.get('theme')
  if (!themeColors) {
    themeColors = window.location.search.match(/theme=([0-9a-fA-F-]+)/)
    if (themeColors) {
      themeColors = themeColors[1]
      Cookies.set('theme', themeColors)
    }
  }
  if (themeColors) {
    themeColors = themeColors.split('-')
    const primaryColor = themeColors[0]
    const searchFieldBgColor = themeColors[1] || primaryColor
    addRules([
      // overwrite primary color
      `.primary-color { color: #${primaryColor}; }`,
      `.primary-bgcolor, .nav-bar-bgcolor, .preview-header-bgcolor { background-color: #${primaryColor}; }`,
      `.primary-bdcolor { border-color: #${primaryColor}; }`,
      // 第三方组件、伪元素 需额外覆盖
      `a, .van-dialog__confirm, .van-dialog__confirm:active, alert-dialog .van-button__text, .van-actionsheet .active { color: #${primaryColor} }`,
      `.video-js .vjs-play-progress, .filter-tabs .filter-item.active::after { background: #${primaryColor}; }`,
      `.van-button--primary { background-color: #${primaryColor}; border: 1px solid #${primaryColor}; }`,
      `.van-field input, .van-field textarea { caret-color: #${primaryColor}; }`,
      `.van-loading--black circle { stroke: #${primaryColor}; }`,
      // 搜索头部输入框背景色
      `.search-main .search-header .van-field { background-color: #${searchFieldBgColor} }`
    ])
  }

  // 企业微信标题栏颜色自定义
  let inWework = Cookies.get('wework')
  if (!inWework && /from=wework/.test(window.location.search)) {
    inWework = 1
    Cookies.set('wework', 1)
  }
  if (inWework) {
    addRules([
      '.nav-bar-bgcolor { background-color: #fff; color: #000; border-bottom: 1px solid #e3e3e7; }',
      '.title-bar.nav-bar-bgcolor { border-bottom: none }',
      '.file-header .van-nav-bar__text, .van-nav-bar__title, .file-header .msg-icon-box, .file-select .title-bar, .search-main .search-header .van-field input { color: #000; }',
      '.search-main .search-header .van-field { background-color: #f6f7f9; }',
      '.search-main .search-header .van-field .van-icon { color: #b2b7ca }',
      '.search-main .search-header .van-field input::-webkit-input-placeholder { color: #c1c1c1; }',
      '.preview-header-bgcolor { background-color: #4b545c; }'
    ])
  }
}
